import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sm:flex sm:justify-center" }
const _hoisted_2 = ["href"]

import type { TagProps } from "./TagProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'TagComponent',
  props: {
    text: {},
    href: {},
    label: {},
    buttonTextColor: {},
    textColor: {},
    borderColor: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex flex-wrap items-center gap-x-1 relative rounded-md px-3 py-1 text-sm/6 border",
      style: _normalizeStyle({ borderColor: _ctx.borderColor })
    }, [
      _createElementVNode("span", {
        class: "opacity-70",
        style: _normalizeStyle({ color: _ctx.textColor })
      }, _toDisplayString(_ctx.text), 5),
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: _ctx.href,
            class: "flex items-center gap-x-1 font-semibold",
            style: _normalizeStyle({
                    color: _ctx.buttonTextColor,
                })
          }, [
            _cache[0] || (_cache[0] = _createElementVNode("span", {
              class: "absolute inset-0",
              "aria-hidden": "true"
            }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.label) + " ", 1),
            _cache[1] || (_cache[1] = _createElementVNode("span", { "aria-hidden": "true" }, "→", -1))
          ], 12, _hoisted_2))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}
}

})